<template>
    <div class="col-md-3">
        <div class="card"
             :class="{
                'bestTpv' : bestTpv && isPremium(),
                'cashActive' : card.totalTpvOnline >= 1 && !(bestTpv && isPremium()),
                'caducada': card.caducada == 1,
                'cashClosed' : card.totalTpvOnline == 0}"
             @click="loadBusiness(card.idBusiness)">
            <div class="content-card">
                <div class="row">
                    <div class="col-md-12" id="nameShow">
                        <div class="row" >
                            <div class="col-md-10" style="display:flex; flex-direction: row; align-items: center;">
                                {{card.nameBusiness}}
                                <div v-if="bestTpv && isPremium()" style="margin-left:15px"> <i class="fa-solid fa-star"></i> </div>
                            </div>
                            
                            <div v-if="card.proximoACaducar && !card.caducada" class="col-md-1 text-right">
                                <i v-tooltip.top-center="$i18n.t('suLicenciaDeNumierOnlineEstaAPuntoDeCaducar')"
                                   class="fas fa-info-circle"></i>
                            </div>
                            <div v-if="card.totalTpv > 1" class="col-md-12 text-right">
                                <small>({{card.totalTpvOnline}} / {{card.totalTpv}} TPVs)
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" id="value" v-if="card.totalTpvOnline >= 1">
                        <span>{{card.value | currency}}</span>
                    </div>
                    <div class="col-md-12" id="value-closed" v-else-if="card.caducada!=1">
                        <span style="font-size: 0.6em">{{$t("cajaCerrada")}}</span>
                    </div>
                    <div class="col-md-12" id="value-caducada" v-else>
                        <span style="font-size: 0.6em">{{$t("licenciaCaducada")}}</span>
                    </div>
                </div>
                <div v-if=" card.totalTpvOnline >= 1" id="lastdate">
                    <i class="fa fa-sync-alt"></i> {{card.lastDate | timeago}}
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';

    export default {
        name: 'card-online',
        props: ['card', 'bestTpv'],
  
        methods: {
            loadBusiness(idBusiness) {
                if (this.card.caducada == 0 && this.card.totalTpvOnline > 0) {
                    this.$router.push({name: 'online-detail', params: {idBusiness: idBusiness}})

                }
            },
            isPremium() {

                return this.$store.state.premiumProfile

            },
        },

        // created(){
        //     console.log("Premium --> " + this.premiumProfile + " // BestTpv --> " + this.bestTpv)
        //     //console.log(this.bestTpv)
        // }
    }

</script>
<style scoped>

    .card {
        color: #eee;
        padding: 15px;
        text-shadow: 1px 1px #333;
    }

    .card:hover {
        cursor: pointer;
        opacity: 0.8;
    }

    #nameShow {
        font-size: 1.1em;
    }

    #value {
        text-align: center;
        font-size: 2em;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    #value-closed {
        text-align: center;
        font-size: 1.7em;
        margin-top: 25px;
        margin-bottom: 24px;
    }

    #value-caducada {
        text-align: center;
        font-size: 1.7em;
        margin-top: 25px;
        margin-bottom: 24px;
    }

    #lastdate {
        font-size: 0.9em;
    }

    .bestTpv {
        background-color: rgb(217, 150, 15);
    }
    .cashActive {
        background-color: #00A3AD;
    }

    .cashClosed {
        background-color: #767676;
    }

    .caducada {
        background-color: #bb1d49;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/CardOnline.vue